export var DbSyncInfoRequestUserTypeEnum;
(function (DbSyncInfoRequestUserTypeEnum) {
    DbSyncInfoRequestUserTypeEnum["STAFF"] = "STAFF";
    DbSyncInfoRequestUserTypeEnum["BLACKLIST"] = "BLACKLIST";
    DbSyncInfoRequestUserTypeEnum["GUEST"] = "GUEST";
})(DbSyncInfoRequestUserTypeEnum || (DbSyncInfoRequestUserTypeEnum = {}));
export var DbSyncInfoRequestStatusEnum;
(function (DbSyncInfoRequestStatusEnum) {
    DbSyncInfoRequestStatusEnum["UPLOADING"] = "UPLOADING";
    DbSyncInfoRequestStatusEnum["LOADED"] = "LOADED";
})(DbSyncInfoRequestStatusEnum || (DbSyncInfoRequestStatusEnum = {}));
